
































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/types";
import { androidStatusBarHeight } from "@/utils/statusBarHeight";
import EventBus from "@/utils/eventBus";
import CasinoEntranceButton from "@/views/coinStore/casinoEntranceButton/CasinoEntranceButton.vue";

@Component({
  components: {
    CasinoEntranceButton
  }
})
export default class Tab extends Vue {
  @Getter(types.GETTER_CURRENT_INS_USER_INFO) private currentInsUserInfo: any;
  @Action(types.ROUTER_PUSH) private routerPush: any;
  @Prop({
    default: [{ labelColor: "" }]
  })
  private tabsNav!: any[];
  @Prop() private value!: number;
  @Prop({ default: 36 })
  private labelWidth!: number;
  @Prop({
    default: false
  })
  private router?: boolean;
  @Prop({
    default: false
  })
  private userAccountSelect?: boolean;
  @Prop({
    default: false
  })
  private leftIcon?: any;
  @Prop({
    default: ""
  })
  private border?: boolean;
  @Prop({
    default: ""
  })
  private layout?: string;
  @Prop({
    default: 1
  })
  private percentWidth!: number; //tabInner的宽度占整个tab的宽度
  @Prop({
    default: {}
  })
  private specialStyle: any;

  private offsetX: number = 0; //底部状态条的位置

  private activeIndex: number = 0; //当前激活状态的状态index

  private tabsEmptyWidth: any = 0;
  private tabItemsWidthList: any = [];

  @Watch("activeIndex")
  private onChildChanged(val: string, oldVal: string) {
    this.setOffsetX(this.activeIndex);
  }

  @Watch("value")
  private valuechange(val: string, oldVal: string) {
    this.activeIndex = this.value;
  }

  private mounted() {
    //初始化宽度:
    this.tabsEmptyWidth = window.screen.width * this.percentWidth;
    // console.log("this.tabsEmptyWidth===>", this.tabsEmptyWidth);
    // this.setOffsetX();
    this.initTabWidth();
  }

  private initTabWidth() {
    this.$nextTick(() => {
      for (let i = 0; i < this.tabsNav.length; i++) {
        const tabItem: any = this.$refs["tabitem" + i];
        const tabWidth = tabItem[0] && tabItem[0].offsetWidth;
        this.tabItemsWidthList.push(tabWidth);
      }

      this.setOffsetX(this.activeIndex);
    });
  }

  /**
   * @emit修饰了函数的一个传入的第一个参数，逗
   */
  @Emit("input")
  private clickTab(index: number, item: any) {
    this.activeIndex = index;
    if (this.router) {
      this.routerPush({
        name: item.pathName
      });
    }
  }

  get userPic() {
    return this.currentInsUserInfo ? this.currentInsUserInfo.userPic : false;
  }

  private get currentLabelColor() {
    return this.tabsNav[this.activeIndex].labelColor;
  }

  private get lineStyle() {
    return {
      transform: "translate3d(" + this.offsetX + "px,0,0)",
      backgroundColor: this.currentLabelColor
    };
  }

  get leftMargin() {
    if (this.leftIcon === "casino" && this.tabsNav.length > 2) {
      return 25;
    }
    return 0;
  }

  get androidStatusBarHeight() {
    return androidStatusBarHeight;
  }

  private clickUserAccount() {
    this.$emit("clickUserAccount");
  }

  private leftIconClick() {
    this.$emit("leftIconClick");
  }

  private setOffsetX(val: number) {
    // const tabsWidth: number = this.tabsEmptyWidth;
    // const tabsLength = this.tabsNav.length;
    // const itemWidth = tabsWidth / tabsLength;
    // this.offsetX =
    //   (itemWidth - this.labelWidth + this.leftMargin) / 2 +
    //   this.activeIndex * itemWidth;
    let leftWidth = 0;
    for (let i = 0; i <= val; i++) {
      leftWidth += this.tabItemsWidthList[i];
    }
    this.offsetX =
      leftWidth - this.tabItemsWidthList[val] / 2 - this.labelWidth / 2;
  }
}
